
// import Notice from "~/components/home/notice.vue";
import BannerTop from "@/components/home/bannerTop.vue";
import CommonTitle from "@/components/home/commonTitle.vue";
export default {
  name:"rigel",
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      bannerUrl:require("@/static/images/coreTechnology/banner.png"),
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/coreTechnology/rigel/rigel1.png`),
          imgStyle:{
            width:"386px",
            height:"620px"
          }
        }
      ],
    }
  },
  computed: {
    contentList () {
      return this.$t('technology.rigel.contentList')
    },
  },
}
